// extracted by mini-css-extract-plugin
module.exports = {"name-form":"NameForm_name-form__8Ci_1","name-form--field":"NameForm_name-form--field__PK_DK"};